import {Injectable} from '@angular/core';
import {AngularFirestore} from 'angularfire2/firestore';
import {Observable} from 'rxjs/Observable';
import {Subject} from 'rxjs/Subject';

import {FirebaseStorageService} from './firebase-storage.service';
import {RepairWithID} from '../../interfaces/repair.interface';
import {FirebaseNotesService} from './notes.service';


@Injectable()
export class FirebaseLandlordService {

  constructor(private afs: AngularFirestore,
              private storeService: FirebaseStorageService,
              private noteService: FirebaseNotesService) {
  }


  /**
   *
   * @param {string} uid
   * @returns {Observable<DocumentChangeAction[]>}
   */
  getLandlordAtOrganizaion(org_id: string): Observable<any> {
    const list = this.afs.collection<any>('organizations')
      .doc(org_id).collection('users',
        users => users.where('role', '==', 'owner'));
        return list.valueChanges();
  }


  /**
   *
   * @param {string} uid
   * @returns {Observable<DocumentChangeAction[]>}
   */
  checkActiveTenantsPerProperty(org_id: string, property_id: string): Observable<any> {
    const list = this.afs.collection<any>('organizations')
      .doc(org_id).collection('properties').doc(property_id).collection('users',
        users => users.where('status', '==', true));

    return list.valueChanges();
  }


  /**
   *
   * @param {string} uid
   * @returns {Observable<DocumentChangeAction[]>}
   */
  getTenantOfPropertyByUid(org_id: string, property_id: string, uid: string): Observable<any> {
    const tenantRef = this.afs.collection<any>('organizations')
      .doc(org_id).collection('properties').doc(property_id).collection('users').doc(uid);

    return tenantRef.valueChanges();
  }


  /**
   *
   * @param {string} org_id
   * @param {string} property_id
   * @param tenant_id
   * @param {boolean} value
   * @returns {Observable<any>}
   */
  updateTenantStatus(org_id: string, property_id: string, tenant_id, value: boolean) {
    const object = this.afs.collection<any>('organizations')
      .doc(org_id).collection('properties').doc(property_id)
      .collection('users').doc(tenant_id);

    const transaction = object.update({
      status: value
    });

    return this.fromFirebaseAuthPromise(transaction);
  }


  /**
   * @param {string} org_id
   * @param {string} property_id
   * @param {string} tenant_id
   * @param formData
   * @returns {Observable<any>}
   */
  updateTenantAtProperty(org_id: string, property_id: string, tenant_id: string, formData: any): Observable<any> {

    const tenantRef = this.afs.collection<any>('organizations').doc(org_id).collection('properties')
      .doc(property_id).collection('users').doc(tenant_id);


    // Populate fields on Repair object //
    const transaction = tenantRef.update({
      firstName: formData.firstName,
      lastName: formData.lastName,
      address: formData.address,
      phone: formData.phone,
      email: formData.email,
      movedIn: formData.movedIn,
    });

    return this.fromFirebaseAuthPromise(transaction);

  }


  /**
   * Update Repair to DB @ [organizations > org_id > properties > property_id > repairs > repair_id ]
   * @param {string} org_id
   * @param {string} property_id
   * @param {any} formData
   * @param {string} imagePath //
   * @returns {Observable<firebase.firestore.DocumentReference>}
   */
  deleteRepairFromProperty(org_id: string, property_id: string, repair: RepairWithID): Observable<any> {
    const deleteRepairRef = this.afs.collection<any>('organizations')
      .doc(org_id).collection('properties').doc(property_id).collection('repairs').doc(repair.id);

    const imageCheck = repair.image;
    const response = [];
    // Init variables  //
    if (imageCheck) {
      console.log('Delete repair with Image and Values');
      // Use this method if Image is available //
      return this.fromFirebaseAuthPromise(deleteRepairRef.delete()
        .then(() => this.storeService.removeFile(repair.imagePath))
        .then(() => this.noteService.deleteNoteByItemID(org_id, property_id, repair.id))
        .catch(error => {
          console.log(error);
          return error;
        })
      );
    } else {
      console.log('Delete repair without Image and Values: ');
      return this.fromFirebaseAuthPromise(deleteRepairRef.delete()
        .then(() => this.noteService.deleteNoteByItemID(org_id, property_id, repair.id))
        .catch(error => {
          console.log(error);
          return error;
        })
      );
    }
  }


  // Convert Promise of Firebase to an Observable
  fromFirebaseAuthPromise(promise): Observable<any> {

    const subject = new Subject<any>();

    promise
      .then(res => {
          subject.next(res);
          subject.complete();
        },
        err => {
          subject.error(err);
          subject.complete();
        }
      );
    return subject.asObservable();
  }


}



// WEBPACK FOOTER //
// C:/Clients/rent-hero/web-application/src/app/_shared/services/firebase/landlord.service.ts